import React from "react";
import PageTemplate from "./PageTemplate";
import { LineAddButton, HeroSection, Tagline, LINE_BOT_URL } from "./LineShared";

const LineJa = () => {
  return (
    <PageTemplate>

      <HeroSection>
        <h1>BabbleOn + LINE</h1>
        <Tagline>
          LINEで誰とでも、どんな言語でもチャット。新しいアプリ不要、コピペ不要。
          BabbleOnをLINEに追加するだけで会話が始まります。
        </Tagline>
        <LineAddButton
          href={LINE_BOT_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/line-icon.png" alt="LINE" />
          BabbleOnをLINEに追加
        </LineAddButton>
      </HeroSection>

      <h2>💬 使い方</h2>
      <p>
        LINEでBabbleOnを友だち追加します。<strong style={{display: 'inline', fontSize: 'inherit', marginTop: 0, marginBottom: 0}}>Start a Babble</strong>をタップして、
        相手が話す言語を選び、招待リンクをシェアするだけ。あとはお互いLINEの中で
        自分の言語でチャットすれば、BabbleOnがリアルタイムですべてのメッセージを翻訳します。
      </p>

      <h2>🇯🇵 LINEコミュニティのために</h2>
      <p>
        LINEは日本や東南アジアでのコミュニケーションの中心です。BabbleOnはその会話に
        直接つながります — 外国人が近所の人とチャットしたり、国際カップルが家族と
        話したり、旅行者が新しい街を楽しんだり。LINEを使っていれば、BabbleOnは
        すぐに使えます。
      </p>

      <h2>🔄 DMでリアルタイム翻訳</h2>
      <p>
        すべてのメッセージがAIで瞬時に翻訳され、LINEのDMに直接届きます。送信者の
        名前とプロフィール写真も表示されるので、自然な会話のように感じられます。
        相手にはあなたのメッセージが相手の言語で、あなたには相手のメッセージが
        あなたの言語で表示されます。
      </p>

      <h2>⚡ アプリのダウンロード不要</h2>
      <p>
        誰も新しいアプリをダウンロードしたり、アカウントを作成する必要はありません。
        招待リンクやQRコードをシェアすれば、チャット相手はそれをスキャンまたは
        タップするだけで参加できます。すべてLINEの中で完結します。
      </p>

      <h2 style={{textAlign: 'center', marginTop: '2.5rem'}}>試してみませんか？</h2>
      <p style={{textAlign: 'center'}}>
        BabbleOnをLINEに追加して、数秒で翻訳チャットを始めましょう。
      </p>
      <div style={{textAlign: 'center', marginTop: '0.5rem'}}>
        <LineAddButton
          href={LINE_BOT_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/line-icon.png" alt="LINE" />
          BabbleOnをLINEに追加
        </LineAddButton>
      </div>

    </PageTemplate>
  );
};

export default LineJa;
